// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Property__Components = require("../../../reason/clients/components/Property/Property__Components.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyPage__ShowingsList = require("../../propertyPage/PropertyPage__ShowingsList.bs.js");
var PropertyWizardFormRelay__Validators__Showings = require("./PropertyWizardFormRelay__Validators__Showings.bs.js");
var PropertyWizardRelayPreviewShowingsList_draft_graphql = require("../../../__generated__/PropertyWizardRelayPreviewShowingsList_draft_graphql.bs.js");
var PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql = require("../../../__generated__/PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.bs.js");

var convertFragment = PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewShowingsList_displayHelpers_graphql.node, convertFragment, fRef);
}

var DisplayHelpersFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = PropertyWizardRelayPreviewShowingsList_draft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayPreviewShowingsList_draft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayPreviewShowingsList_draft_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayPreviewShowingsList_draft_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayPreviewShowingsList_draft_graphql.node, convertFragment$1, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Preview__ShowingsList(props) {
  var onEditForm = props.onEditForm;
  var draft = use$1(props.draft);
  var displayHelpers = use(props.displayHelpers);
  var showings = Core__Option.getOr(displayHelpers.showings, []).map(function (s) {
        return s.fragmentRefs;
      });
  var showingsValid = PropertyWizardFormRelay__Validators__Showings.use(draft.fragmentRefs);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(PropertyPage__ShowingsList.make, {
                      showings: showings,
                      shouldShowPropertyDetails: true
                    }),
                showingsValid === "Invalid" ? JsxRuntime.jsx(Property__Components.MissingFieldMarker.make, {
                        text: "One or more entered showings has errors.",
                        onClick: (function (_event) {
                            onEditForm("showings");
                          })
                      }) : null
              ],
              className: "border-1 border-gray-800 rounded-md"
            });
}

var MissingFieldMarker;

var Validators;

var make = PropertyWizardRelay__Preview__ShowingsList;

exports.MissingFieldMarker = MissingFieldMarker;
exports.Validators = Validators;
exports.DisplayHelpersFragment = DisplayHelpersFragment;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* react/jsx-runtime Not a pure module */
